import Superstore, { createAsyncLocalSuperstore, createIndexedDBSuperstore, createSyncLocalSuperstore } from './Superstore';
import LocalStorageBackend from './localstorage';
import IndexedDBBackend from './indexeddb';
export default Superstore;
export const LocalStorage = LocalStorageBackend;
export const IndexedDB = IndexedDBBackend;
export { createAsyncLocalSuperstore, createIndexedDBSuperstore, createSyncLocalSuperstore };